module.exports = __webpack_public_path__ + "static/media/blueExpressCompleteLogo.f4a88c41.webp";